import { render, staticRenderFns } from "./OffMarketPINAccess.vue?vue&type=template&id=53f74200&scoped=true&"
import script from "./OffMarketPINAccess.vue?vue&type=script&lang=ts&"
export * from "./OffMarketPINAccess.vue?vue&type=script&lang=ts&"
import style0 from "./OffMarketPINAccess.vue?vue&type=style&index=0&id=53f74200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f74200",
  null
  
)

export default component.exports